import React from 'react';

/**
 * @param {import('./lib/propTypes').DividerProps} props
 */

const Divider = ({ direction = 'horizontal', className = '', color = 'neutral-200' }) => {
  const lineStyles =
    direction === 'horizontal' ? `h-[1px] w-full bg-${color}` : `w-[1px] h-full bg-${color}`;

  return <div className={`${lineStyles} ${className}`} />;
};

export default Divider;
